"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rules_1 = __importDefault(require("./markdown/rules"));

var mark_1 = __importDefault(require("../rules/mark"));

var checkboxes_1 = __importDefault(require("../rules/checkboxes"));

var embeds_1 = __importDefault(require("../rules/embeds"));

var breaks_1 = __importDefault(require("../rules/breaks"));

var tables_1 = __importDefault(require("../rules/tables"));

var notices_1 = __importDefault(require("../rules/notices"));

var underlines_1 = __importDefault(require("../rules/underlines"));

var emoji_1 = __importDefault(require("../rules/emoji"));

var defaultRules = [embeds_1.default, breaks_1.default, checkboxes_1.default, mark_1.default({
  delim: "==",
  mark: "highlight"
}), mark_1.default({
  delim: "!!",
  mark: "placeholder"
}), underlines_1.default, tables_1.default, notices_1.default, emoji_1.default];

function renderToHtml(markdown) {
  var rulePlugins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultRules;
  return rules_1.default({
    plugins: rulePlugins
  }).render(markdown).trim();
}

exports.default = renderToHtml;